<template lang="pug">
  div(v-if='person')

    ods-row(:gutter='32')
      ods-col(:span='24')
        h2.mocuetitle {{ $t('loyalty.personalData') }}

    ods-row(:gutter='32')
      ods-col(:span='8')
        h2.mocueh2 {{ $t('loyalty.IdNumber') }}
        span.mocuespan {{ person.desctidc }} - {{ person.idclient }}
    div
      ods-row(:gutter='32')
        ods-col(:span='8')
          h2.mocueh2 {{ $t('loyalty.name') }}
          span.mocuespan {{ person.nombre ? person.nombre : '' }}
        ods-col(:span='8')
          h2.mocueh2 {{ $t('loyalty.firstName') }}
          span.mocuespan {{ person.apellid1 ? person.apellid1 : '' }}
        ods-col(:span='8')
          h2.mocueh2 {{ $t('loyalty.lastName') }}
          span.mocuespan {{ person.apellid2 ? person.apellid2 : '' }}

      ods-row(:gutter='32')
        ods-col(:span='8')
          h2.mocueh2 {{ $t('loyalty.gender') }}
          span.mocuespan {{ person.sexo && person.sexo === 'M' ? $t('loyalty.female') : person.sexo && person.sexo === 'V' ? $t('loyalty.male') : $t('el.table.emptyText') }}
        ods-col(:span='8')
          h2.mocueh2 {{ $t('loyalty.maritalStatus') }}
          span.mocuespan {{ person.indestciv ? $t(`loyalty.maritalStatusArr[${person.indestciv}]`) : $t('el.table.emptyText') }}
        ods-col(:span='8')
          h2.mocueh2 {{ $t('loyalty.birthDate') }}
          span.mocuespan {{ person.fecnac | formatDateLocale}}

      ods-row(:gutter='32')
        ods-col(:span='24')
          h2.mocuetitle {{ $t('loyalty.adress') }}

      ods-row(:gutter='32')
        ods-col(:span='8')
          h2.mocueh2 {{ $t('loyalty.region') }}
          span.mocuespan {{ person.codregion ? person.codregion : '' }}
        ods-col(:span='8')
          h2.mocueh2 {{ $t('loyalty.city') }}
          span.mocuespan {{ person.poblacion ? person.poblacion : '' }}
        ods-col(:span='8')
          h2.mocueh2 {{ $t('loyalty.postalCode') }}
          span.mocuespan {{ person.codpostal ? person.codpostal : $t('el.table.emptyText') }}

      ods-row(:gutter='32')
        ods-col(:span='8')
          h2.mocueh2 {{ $t('loyalty.email') }}
          span.mocuespan {{ person.desclave1 ? person.desclave1 : $t('el.table.emptyText') }}
        ods-col(:span='8')
          h2.mocueh2 {{ $t('loyalty.phone') }}
          span.mocuespan {{ person.desclave2 ? person.desclave2 : $t('el.table.emptyText') }}

</template>
<script>
export default {
  name: 'VistaCliente',
  props: ['person']
}
</script>
<style lang="scss">
</style>
